var _defs, _polyline, _line, _polyline2, _line2, _polyline3, _line3, _polyline4, _line4, _polyline5, _line5, _polyline6, _line6, _polyline7, _line7, _polyline8, _line8, _polyline9, _line9, _polyline10, _line10, _polyline11, _line11, _polyline12, _line12, _polyline13, _line13, _polyline14, _line14, _polyline15, _line15, _polyline16, _line16, _polyline17, _line17, _polyline18, _line18, _polyline19, _line19, _polyline20, _line20, _polyline21, _line21, _polyline22, _line22, _polyline23, _line23, _polyline24, _line24, _polyline25, _line25, _polyline26, _line26, _polyline27, _line27, _polyline28, _line28, _polyline29, _line29, _polyline30, _line30, _polyline31, _line31, _polyline32, _line32, _polyline33, _line33, _polyline34, _line34, _polyline35, _line35, _polyline36, _line36, _polyline37, _line37, _polyline38, _line38, _polyline39, _line39, _polyline40, _line40, _polyline41, _line41, _polyline42, _line42, _polyline43, _line43, _polyline44, _line44, _polyline45, _line45, _polyline46, _line46, _polyline47, _line47, _polyline48, _line48, _polyline49, _line49, _polyline50, _line50, _polyline51, _line51, _polyline52, _line52, _polyline53, _line53, _polyline54, _line54, _polyline55, _line55, _polyline56, _line56, _polyline57, _line57, _polyline58, _line58, _polyline59, _line59, _polyline60, _line60, _polyline61, _line61, _polyline62, _line62, _polyline63, _line63, _polyline64, _line64, _polyline65, _line65, _polyline66, _line66, _polyline67, _line67, _polyline68, _line68, _polyline69, _line69, _polyline70, _line70, _polyline71, _line71, _polyline72, _line72, _polyline73, _line73, _polyline74, _line74, _polyline75, _line75, _polyline76, _line76, _polyline77, _line77, _polyline78, _line78, _polyline79, _line79, _polyline80, _line80, _polyline81, _line81, _polyline82, _line82, _polyline83, _line83, _polyline84, _line84, _polyline85, _line85, _polyline86, _line86, _polyline87, _line87, _polyline88, _line88, _polyline89, _line89, _polyline90, _line90, _polyline91, _line91, _polyline92, _line92, _polyline93, _line93, _polyline94, _line94, _polyline95, _line95, _polyline96, _line96, _polyline97, _line97, _polyline98, _line98, _polyline99, _line99, _polyline100, _line100, _polyline101, _line101, _polyline102, _line102, _polyline103, _line103, _polyline104, _line104, _polyline105, _line105, _polyline106, _line106, _polyline107, _line107, _polyline108, _line108, _polyline109, _line109, _polyline110, _line110, _polyline111, _line111, _polyline112, _line112, _polyline113, _line113, _polyline114, _line114, _polyline115, _line115, _polyline116, _line116, _polyline117, _line117, _polyline118, _line118, _polyline119, _line119, _polyline120, _line120, _polyline121, _line121, _polyline122, _line122, _polyline123, _line123, _polyline124, _line124, _polyline125, _line125, _polyline126, _line126, _polyline127, _line127, _polyline128, _line128, _polyline129, _line129, _polyline130, _line130, _polyline131, _line131, _polyline132, _line132, _polyline133, _line133, _polyline134, _line134, _polyline135, _line135, _polyline136, _line136, _polyline137, _line137, _polyline138, _line138, _polyline139, _line139, _polyline140, _line140, _polyline141, _line141, _polyline142, _line142, _polyline143, _line143, _polyline144, _line144, _polyline145, _line145, _polyline146, _line146, _polyline147, _line147, _polyline148, _line148, _polyline149, _line149, _polyline150, _line150, _polyline151, _line151, _polyline152, _line152, _polyline153, _line153, _polyline154, _line154, _polyline155, _line155, _polyline156, _line156, _polyline157, _line157, _polyline158, _line158, _polyline159, _line159, _polyline160, _line160, _polyline161, _line161, _polyline162, _line162, _polyline163, _line163, _polyline164, _line164, _polyline165, _line165, _polyline166, _line166, _polyline167, _line167, _polyline168, _line168, _polyline169, _line169, _polyline170, _line170, _polyline171, _line171, _polyline172, _line172, _polyline173, _line173, _polyline174, _line174, _polyline175, _line175, _polyline176, _line176, _polyline177, _line177, _polyline178, _line178, _polyline179, _line179, _polyline180, _line180, _polyline181, _line181, _polyline182, _line182, _polyline183, _line183, _polyline184, _line184, _polyline185, _line185, _polyline186, _line186, _polyline187, _line187, _polyline188, _line188, _polyline189, _line189, _polyline190, _line190, _polyline191, _line191, _polyline192, _line192, _polyline193, _line193, _polyline194, _line194, _polyline195, _line195, _polyline196, _line196, _polyline197, _line197, _polyline198, _line198, _polyline199, _line199, _polyline200, _line200, _polyline201, _line201, _polyline202, _line202, _polyline203, _line203, _polyline204, _line204, _polyline205, _line205, _polyline206, _line206, _polyline207, _line207, _polyline208, _line208, _polyline209, _line209, _polyline210, _line210, _polyline211, _line211, _polyline212, _line212, _polyline213, _line213, _polyline214, _line214, _polyline215, _line215, _polyline216, _line216, _polyline217, _line217, _polyline218, _line218, _polyline219, _line219, _polyline220, _line220, _polyline221, _line221, _polyline222, _line222, _polyline223, _line223, _polyline224, _line224, _polyline225, _line225, _polyline226, _line226, _polyline227, _line227, _polyline228, _line228, _polyline229, _line229, _polyline230, _line230, _polyline231, _line231, _polyline232, _line232, _polyline233, _line233, _polyline234, _line234, _polyline235, _line235, _polyline236, _line236, _polyline237, _line237, _polyline238, _line238, _polyline239, _line239, _polyline240, _line240, _polyline241, _line241, _polyline242, _line242, _polyline243, _line243, _polyline244, _line244, _polyline245, _line245, _polyline246, _line246, _polyline247, _line247, _polyline248, _line248, _polyline249, _line249, _polyline250, _line250, _polyline251, _line251, _polyline252, _line252, _polyline253, _line253, _polyline254, _line254, _polyline255, _line255, _polyline256, _line256, _polyline257, _line257, _polyline258, _line258, _polyline259, _line259, _polyline260, _line260, _polyline261, _line261, _polyline262, _line262, _polyline263, _line263, _polyline264, _line264, _polyline265, _line265, _polyline266, _line266, _polyline267, _line267, _polyline268, _line268, _polyline269, _line269, _polyline270, _line270, _polyline271, _line271, _polyline272, _line272, _polyline273, _line273, _polyline274, _line274, _polyline275, _line275, _polyline276, _line276, _polyline277, _line277, _polyline278, _line278, _polyline279, _line279, _polyline280, _line280, _polyline281, _line281, _polyline282, _line282, _polyline283, _line283, _polyline284, _line284, _polyline285, _line285, _polyline286, _line286, _polyline287, _line287, _polyline288, _line288, _polyline289, _line289, _polyline290, _line290, _polyline291, _line291, _polyline292, _line292, _polyline293, _line293, _polyline294, _line294, _polyline295, _line295, _polyline296, _line296, _polyline297, _line297, _polyline298, _line298, _polyline299, _line299, _polyline300, _line300, _polyline301, _line301, _polyline302, _line302, _polyline303, _line303, _polyline304, _line304, _polyline305, _line305, _polyline306, _line306, _polyline307, _line307, _polyline308, _line308, _polyline309, _line309, _polyline310, _line310, _polyline311, _line311, _polyline312, _line312, _polyline313, _line313, _polyline314, _line314, _polyline315, _line315, _polyline316, _line316, _polyline317, _line317, _polyline318, _line318, _polyline319, _line319, _polyline320, _line320, _polyline321, _line321, _polyline322, _line322, _polyline323, _line323, _polyline324, _line324, _polyline325, _line325, _polyline326, _line326, _polyline327, _line327, _polyline328, _line328, _polyline329, _line329, _polyline330, _line330, _polyline331, _line331, _polyline332, _line332, _polyline333, _line333, _polyline334, _line334, _polyline335, _line335, _polyline336, _line336, _polyline337, _line337, _polyline338, _line338, _polyline339, _line339, _polyline340, _line340, _polyline341, _line341, _polyline342, _line342, _polyline343, _line343, _polyline344, _line344, _polyline345, _line345, _polyline346, _line346, _polyline347, _line347, _polyline348, _line348, _polyline349, _line349, _polyline350, _line350, _polyline351, _line351, _polyline352, _line352, _polyline353, _line353, _polyline354, _line354, _polyline355, _line355, _polyline356, _line356, _polyline357, _line357, _polyline358, _line358, _polyline359, _line359, _polyline360, _line360, _polyline361, _line361, _polyline362, _line362, _polyline363, _line363, _polyline364, _line364, _polyline365, _line365, _polyline366, _line366, _polyline367, _line367, _polyline368, _line368, _polyline369, _line369, _polyline370, _line370, _polyline371, _line371, _polyline372, _line372, _polyline373, _line373, _polyline374, _line374, _polyline375, _line375, _polyline376, _line376, _polyline377, _line377, _polyline378, _line378, _polyline379, _line379, _polyline380, _line380, _polyline381, _line381, _polyline382, _line382, _polyline383, _line383, _polyline384, _line384, _polyline385, _line385, _polyline386, _line386, _polyline387, _line387, _polyline388, _line388, _polyline389, _line389, _polyline390, _line390, _polyline391, _line391, _polyline392, _line392, _polyline393, _line393, _polyline394, _line394, _polyline395, _line395, _polyline396, _line396, _polyline397, _line397, _polyline398, _line398, _polyline399, _line399, _polyline400, _line400;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreviewOrderBgTab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke:#707070;stroke-miterlimit:10;stroke-width:0.52px;}.cls-2{stroke-dasharray:2.25 2.25;}.cls-3{stroke-dasharray:2.25 2.25;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "34.58 38.6 34.58 39.73 33.46 39.73"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.22,
    y1: 39.73,
    x2: 14.37,
    y2: 39.73
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "13.25 39.73 12.13 39.73 12.13 38.6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.12,
    y1: 36.36,
    x2: 12.12,
    y2: 19.51
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12.13 18.39 12.13 17.27 13.25 17.27"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.49,
    y1: 17.27,
    x2: 32.34,
    y2: 17.27
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "33.46 17.27 34.58 17.27 34.58 18.39"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 34.58,
    y1: 20.63,
    x2: 34.58,
    y2: 37.48
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "62.62 38.6 62.62 39.73 61.5 39.73"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59.25,
    y1: 39.73,
    x2: 42.41,
    y2: 39.73
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "41.29 39.73 40.16 39.73 40.16 38.6"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.16,
    y1: 36.36,
    x2: 40.16,
    y2: 19.51
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.16 18.39 40.16 17.27 41.29 17.27"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.53,
    y1: 17.27,
    x2: 60.38,
    y2: 17.27
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "61.5 17.27 62.62 17.27 62.62 18.39"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.62,
    y1: 20.63,
    x2: 62.62,
    y2: 37.48
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "90.66 38.6 90.66 39.73 89.54 39.73"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.29,
    y1: 39.73,
    x2: 70.45,
    y2: 39.73
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "69.33 39.73 68.2 39.73 68.2 38.6"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.2,
    y1: 36.36,
    x2: 68.2,
    y2: 19.51
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "68.2 18.39 68.2 17.27 69.33 17.27"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.57,
    y1: 17.27,
    x2: 88.42,
    y2: 17.27
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "89.54 17.27 90.66 17.27 90.66 18.39"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.66,
    y1: 20.63,
    x2: 90.66,
    y2: 37.48
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "118.7 38.6 118.7 39.73 117.58 39.73"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 115.33,
    y1: 39.73,
    x2: 98.49,
    y2: 39.73
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "97.36 39.73 96.24 39.73 96.24 38.6"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.24,
    y1: 36.36,
    x2: 96.24,
    y2: 19.51
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "96.24 18.39 96.24 17.27 97.36 17.27"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.61,
    y1: 17.27,
    x2: 116.46,
    y2: 17.27
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "117.58 17.27 118.7 17.27 118.7 18.39"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 118.7,
    y1: 20.63,
    x2: 118.7,
    y2: 37.48
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "146.74 38.6 146.74 39.73 145.62 39.73"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 143.37,
    y1: 39.73,
    x2: 126.53,
    y2: 39.73
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "125.4 39.73 124.28 39.73 124.28 38.6"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 124.28,
    y1: 36.36,
    x2: 124.28,
    y2: 19.51
  })), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "124.28 18.39 124.28 17.27 125.4 17.27"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 127.65,
    y1: 17.27,
    x2: 144.49,
    y2: 17.27
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "145.62 17.27 146.74 17.27 146.74 18.39"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 146.74,
    y1: 20.63,
    x2: 146.74,
    y2: 37.48
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "174.96 38.83 174.96 39.95 173.84 39.95"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.59,
    y1: 39.95,
    x2: 154.74,
    y2: 39.95
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "153.62 39.95 152.5 39.95 152.5 38.83"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 152.5,
    y1: 36.58,
    x2: 152.5,
    y2: 19.74
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "152.5 18.61 152.5 17.49 153.62 17.49"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 155.87,
    y1: 17.49,
    x2: 172.71,
    y2: 17.49
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "173.84 17.49 174.96 17.49 174.96 18.61"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.96,
    y1: 20.86,
    x2: 174.96,
    y2: 37.7
  })), _polyline25 || (_polyline25 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "203.18 39.05 203.18 40.17 202.05 40.17"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 199.81,
    y1: 40.17,
    x2: 182.96,
    y2: 40.17
  })), _polyline26 || (_polyline26 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "181.84 40.17 180.72 40.17 180.72 39.05"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 180.72,
    y1: 36.81,
    x2: 180.72,
    y2: 19.96
  })), _polyline27 || (_polyline27 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "180.72 18.84 180.72 17.71 181.84 17.71"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 184.09,
    y1: 17.72,
    x2: 200.93,
    y2: 17.72
  })), _polyline28 || (_polyline28 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "202.05 17.71 203.18 17.71 203.18 18.84"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 203.18,
    y1: 21.08,
    x2: 203.18,
    y2: 37.93
  })), _polyline29 || (_polyline29 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "34.58 67.75 34.58 68.87 33.46 68.87"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.22,
    y1: 68.87,
    x2: 14.37,
    y2: 68.87
  })), _polyline30 || (_polyline30 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "13.25 68.87 12.13 68.87 12.13 67.75"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.12,
    y1: 65.5,
    x2: 12.12,
    y2: 48.66
  })), _polyline31 || (_polyline31 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12.13 47.54 12.13 46.41 13.25 46.41"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.49,
    y1: 46.41,
    x2: 32.34,
    y2: 46.41
  })), _polyline32 || (_polyline32 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "33.46 46.41 34.58 46.41 34.58 47.54"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 34.58,
    y1: 49.78,
    x2: 34.58,
    y2: 66.63
  })), _polyline33 || (_polyline33 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "62.62 67.75 62.62 68.87 61.5 68.87"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59.25,
    y1: 68.87,
    x2: 42.41,
    y2: 68.87
  })), _polyline34 || (_polyline34 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "41.29 68.87 40.16 68.87 40.16 67.75"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.16,
    y1: 65.5,
    x2: 40.16,
    y2: 48.66
  })), _polyline35 || (_polyline35 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.16 47.54 40.16 46.41 41.29 46.41"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.53,
    y1: 46.41,
    x2: 60.38,
    y2: 46.41
  })), _polyline36 || (_polyline36 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "61.5 46.41 62.62 46.41 62.62 47.54"
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.62,
    y1: 49.78,
    x2: 62.62,
    y2: 66.63
  })), _polyline37 || (_polyline37 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "90.66 67.75 90.66 68.87 89.54 68.87"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.29,
    y1: 68.87,
    x2: 70.45,
    y2: 68.87
  })), _polyline38 || (_polyline38 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "69.33 68.87 68.2 68.87 68.2 67.75"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.2,
    y1: 65.5,
    x2: 68.2,
    y2: 48.66
  })), _polyline39 || (_polyline39 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "68.2 47.54 68.2 46.41 69.33 46.41"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.57,
    y1: 46.41,
    x2: 88.42,
    y2: 46.41
  })), _polyline40 || (_polyline40 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "89.54 46.41 90.66 46.41 90.66 47.54"
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.66,
    y1: 49.78,
    x2: 90.66,
    y2: 66.63
  })), _polyline41 || (_polyline41 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "118.7 67.75 118.7 68.87 117.58 68.87"
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 115.33,
    y1: 68.87,
    x2: 98.49,
    y2: 68.87
  })), _polyline42 || (_polyline42 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "97.36 68.87 96.24 68.87 96.24 67.75"
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.24,
    y1: 65.5,
    x2: 96.24,
    y2: 48.66
  })), _polyline43 || (_polyline43 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "96.24 47.54 96.24 46.41 97.36 46.41"
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.61,
    y1: 46.41,
    x2: 116.46,
    y2: 46.41
  })), _polyline44 || (_polyline44 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "117.58 46.41 118.7 46.41 118.7 47.54"
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 118.7,
    y1: 49.78,
    x2: 118.7,
    y2: 66.63
  })), _polyline45 || (_polyline45 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "146.74 67.75 146.74 68.87 145.62 68.87"
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 143.37,
    y1: 68.87,
    x2: 126.53,
    y2: 68.87
  })), _polyline46 || (_polyline46 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "125.4 68.87 124.28 68.87 124.28 67.75"
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 124.28,
    y1: 65.5,
    x2: 124.28,
    y2: 48.66
  })), _polyline47 || (_polyline47 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "124.28 47.54 124.28 46.41 125.4 46.41"
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 127.65,
    y1: 46.41,
    x2: 144.49,
    y2: 46.41
  })), _polyline48 || (_polyline48 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "145.62 46.41 146.74 46.41 146.74 47.54"
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 146.74,
    y1: 49.78,
    x2: 146.74,
    y2: 66.63
  })), _polyline49 || (_polyline49 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "174.96 67.98 174.96 69.1 173.84 69.1"
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.59,
    y1: 69.1,
    x2: 154.74,
    y2: 69.1
  })), _polyline50 || (_polyline50 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "153.62 69.1 152.5 69.1 152.5 67.98"
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 152.5,
    y1: 65.73,
    x2: 152.5,
    y2: 48.88
  })), _polyline51 || (_polyline51 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "152.5 47.76 152.5 46.64 153.62 46.64"
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 155.87,
    y1: 46.64,
    x2: 172.71,
    y2: 46.64
  })), _polyline52 || (_polyline52 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "173.84 46.64 174.96 46.64 174.96 47.76"
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.96,
    y1: 50.01,
    x2: 174.96,
    y2: 66.85
  })), _polyline53 || (_polyline53 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "203.18 68.2 203.18 69.32 202.05 69.32"
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 199.81,
    y1: 69.32,
    x2: 182.96,
    y2: 69.32
  })), _polyline54 || (_polyline54 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "181.84 69.32 180.72 69.32 180.72 68.2"
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 180.72,
    y1: 65.95,
    x2: 180.72,
    y2: 49.11
  })), _polyline55 || (_polyline55 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "180.72 47.99 180.72 46.86 181.84 46.86"
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 184.09,
    y1: 46.86,
    x2: 200.93,
    y2: 46.86
  })), _polyline56 || (_polyline56 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "202.05 46.86 203.18 46.86 203.18 47.99"
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 203.18,
    y1: 50.23,
    x2: 203.18,
    y2: 67.08
  })), _polyline57 || (_polyline57 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "34.58 96.9 34.58 98.02 33.46 98.02"
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.22,
    y1: 98.02,
    x2: 14.37,
    y2: 98.02
  })), _polyline58 || (_polyline58 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "13.25 98.02 12.13 98.02 12.13 96.9"
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.12,
    y1: 94.65,
    x2: 12.12,
    y2: 77.81
  })), _polyline59 || (_polyline59 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12.13 76.69 12.13 75.56 13.25 75.56"
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.49,
    y1: 75.56,
    x2: 32.34,
    y2: 75.56
  })), _polyline60 || (_polyline60 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "33.46 75.56 34.58 75.56 34.58 76.69"
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 34.58,
    y1: 78.93,
    x2: 34.58,
    y2: 95.78
  })), _polyline61 || (_polyline61 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "62.62 96.9 62.62 98.02 61.5 98.02"
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59.25,
    y1: 98.02,
    x2: 42.41,
    y2: 98.02
  })), _polyline62 || (_polyline62 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "41.29 98.02 40.16 98.02 40.16 96.9"
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.16,
    y1: 94.65,
    x2: 40.16,
    y2: 77.81
  })), _polyline63 || (_polyline63 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.16 76.69 40.16 75.56 41.29 75.56"
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.53,
    y1: 75.56,
    x2: 60.38,
    y2: 75.56
  })), _polyline64 || (_polyline64 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "61.5 75.56 62.62 75.56 62.62 76.69"
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.62,
    y1: 78.93,
    x2: 62.62,
    y2: 95.78
  })), _polyline65 || (_polyline65 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "90.66 96.9 90.66 98.02 89.54 98.02"
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.29,
    y1: 98.02,
    x2: 70.45,
    y2: 98.02
  })), _polyline66 || (_polyline66 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "69.33 98.02 68.2 98.02 68.2 96.9"
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.2,
    y1: 94.65,
    x2: 68.2,
    y2: 77.81
  })), _polyline67 || (_polyline67 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "68.2 76.69 68.2 75.56 69.33 75.56"
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.57,
    y1: 75.56,
    x2: 88.42,
    y2: 75.56
  })), _polyline68 || (_polyline68 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "89.54 75.56 90.66 75.56 90.66 76.69"
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.66,
    y1: 78.93,
    x2: 90.66,
    y2: 95.78
  })), _polyline69 || (_polyline69 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "118.7 96.9 118.7 98.02 117.58 98.02"
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 115.33,
    y1: 98.02,
    x2: 98.49,
    y2: 98.02
  })), _polyline70 || (_polyline70 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "97.36 98.02 96.24 98.02 96.24 96.9"
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.24,
    y1: 94.65,
    x2: 96.24,
    y2: 77.81
  })), _polyline71 || (_polyline71 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "96.24 76.69 96.24 75.56 97.36 75.56"
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.61,
    y1: 75.56,
    x2: 116.46,
    y2: 75.56
  })), _polyline72 || (_polyline72 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "117.58 75.56 118.7 75.56 118.7 76.69"
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 118.7,
    y1: 78.93,
    x2: 118.7,
    y2: 95.78
  })), _polyline73 || (_polyline73 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "146.74 96.9 146.74 98.02 145.62 98.02"
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 143.37,
    y1: 98.02,
    x2: 126.53,
    y2: 98.02
  })), _polyline74 || (_polyline74 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "125.4 98.02 124.28 98.02 124.28 96.9"
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 124.28,
    y1: 94.65,
    x2: 124.28,
    y2: 77.81
  })), _polyline75 || (_polyline75 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "124.28 76.69 124.28 75.56 125.4 75.56"
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 127.65,
    y1: 75.56,
    x2: 144.49,
    y2: 75.56
  })), _polyline76 || (_polyline76 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "145.62 75.56 146.74 75.56 146.74 76.69"
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 146.74,
    y1: 78.93,
    x2: 146.74,
    y2: 95.78
  })), _polyline77 || (_polyline77 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "174.96 97.12 174.96 98.25 173.84 98.25"
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.59,
    y1: 98.25,
    x2: 154.74,
    y2: 98.25
  })), _polyline78 || (_polyline78 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "153.62 98.25 152.5 98.25 152.5 97.12"
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 152.5,
    y1: 94.88,
    x2: 152.5,
    y2: 78.03
  })), _polyline79 || (_polyline79 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "152.5 76.91 152.5 75.79 153.62 75.79"
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 155.87,
    y1: 75.79,
    x2: 172.71,
    y2: 75.79
  })), _polyline80 || (_polyline80 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "173.84 75.79 174.96 75.79 174.96 76.91"
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.96,
    y1: 79.16,
    x2: 174.96,
    y2: 96
  })), _polyline81 || (_polyline81 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "203.18 97.35 203.18 98.47 202.05 98.47"
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 199.81,
    y1: 98.47,
    x2: 182.96,
    y2: 98.47
  })), _polyline82 || (_polyline82 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "181.84 98.47 180.72 98.47 180.72 97.35"
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 180.72,
    y1: 95.1,
    x2: 180.72,
    y2: 78.26
  })), _polyline83 || (_polyline83 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "180.72 77.14 180.72 76.01 181.84 76.01"
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 184.09,
    y1: 76.01,
    x2: 200.93,
    y2: 76.01
  })), _polyline84 || (_polyline84 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "202.05 76.01 203.18 76.01 203.18 77.14"
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 203.18,
    y1: 79.38,
    x2: 203.18,
    y2: 96.23
  })), _polyline85 || (_polyline85 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "34.58 126.05 34.58 127.17 33.46 127.17"
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.22,
    y1: 127.17,
    x2: 14.37,
    y2: 127.17
  })), _polyline86 || (_polyline86 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "13.25 127.17 12.13 127.17 12.13 126.05"
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.12,
    y1: 123.8,
    x2: 12.12,
    y2: 106.96
  })), _polyline87 || (_polyline87 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12.13 105.83 12.13 104.71 13.25 104.71"
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.49,
    y1: 104.71,
    x2: 32.34,
    y2: 104.71
  })), _polyline88 || (_polyline88 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "33.46 104.71 34.58 104.71 34.58 105.83"
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 34.58,
    y1: 108.08,
    x2: 34.58,
    y2: 124.92
  })), _polyline89 || (_polyline89 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "62.62 126.05 62.62 127.17 61.5 127.17"
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59.25,
    y1: 127.17,
    x2: 42.41,
    y2: 127.17
  })), _polyline90 || (_polyline90 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "41.29 127.17 40.16 127.17 40.16 126.05"
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.16,
    y1: 123.8,
    x2: 40.16,
    y2: 106.96
  })), _polyline91 || (_polyline91 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.16 105.83 40.16 104.71 41.29 104.71"
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.53,
    y1: 104.71,
    x2: 60.38,
    y2: 104.71
  })), _polyline92 || (_polyline92 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "61.5 104.71 62.62 104.71 62.62 105.83"
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.62,
    y1: 108.08,
    x2: 62.62,
    y2: 124.92
  })), _polyline93 || (_polyline93 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "90.66 126.05 90.66 127.17 89.54 127.17"
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.29,
    y1: 127.17,
    x2: 70.45,
    y2: 127.17
  })), _polyline94 || (_polyline94 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "69.33 127.17 68.2 127.17 68.2 126.05"
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.2,
    y1: 123.8,
    x2: 68.2,
    y2: 106.96
  })), _polyline95 || (_polyline95 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "68.2 105.83 68.2 104.71 69.33 104.71"
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.57,
    y1: 104.71,
    x2: 88.42,
    y2: 104.71
  })), _polyline96 || (_polyline96 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "89.54 104.71 90.66 104.71 90.66 105.83"
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.66,
    y1: 108.08,
    x2: 90.66,
    y2: 124.92
  })), _polyline97 || (_polyline97 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "118.7 126.05 118.7 127.17 117.58 127.17"
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 115.33,
    y1: 127.17,
    x2: 98.49,
    y2: 127.17
  })), _polyline98 || (_polyline98 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "97.36 127.17 96.24 127.17 96.24 126.05"
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.24,
    y1: 123.8,
    x2: 96.24,
    y2: 106.96
  })), _polyline99 || (_polyline99 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "96.24 105.83 96.24 104.71 97.36 104.71"
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.61,
    y1: 104.71,
    x2: 116.46,
    y2: 104.71
  })), _polyline100 || (_polyline100 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "117.58 104.71 118.7 104.71 118.7 105.83"
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 118.7,
    y1: 108.08,
    x2: 118.7,
    y2: 124.92
  })), _polyline101 || (_polyline101 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "146.74 126.05 146.74 127.17 145.62 127.17"
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 143.37,
    y1: 127.17,
    x2: 126.53,
    y2: 127.17
  })), _polyline102 || (_polyline102 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "125.4 127.17 124.28 127.17 124.28 126.05"
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 124.28,
    y1: 123.8,
    x2: 124.28,
    y2: 106.96
  })), _polyline103 || (_polyline103 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "124.28 105.83 124.28 104.71 125.4 104.71"
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 127.65,
    y1: 104.71,
    x2: 144.49,
    y2: 104.71
  })), _polyline104 || (_polyline104 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "145.62 104.71 146.74 104.71 146.74 105.83"
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 146.74,
    y1: 108.08,
    x2: 146.74,
    y2: 124.92
  })), _polyline105 || (_polyline105 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "174.96 126.27 174.96 127.39 173.84 127.39"
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.59,
    y1: 127.4,
    x2: 154.74,
    y2: 127.4
  })), _polyline106 || (_polyline106 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "153.62 127.39 152.5 127.39 152.5 126.27"
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 152.5,
    y1: 124.03,
    x2: 152.5,
    y2: 107.18
  })), _polyline107 || (_polyline107 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "152.5 106.06 152.5 104.94 153.62 104.94"
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 155.87,
    y1: 104.94,
    x2: 172.71,
    y2: 104.94
  })), _polyline108 || (_polyline108 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "173.84 104.94 174.96 104.94 174.96 106.06"
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.96,
    y1: 108.3,
    x2: 174.96,
    y2: 125.15
  })), _polyline109 || (_polyline109 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "203.18 126.5 203.18 127.62 202.05 127.62"
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 199.81,
    y1: 127.62,
    x2: 182.96,
    y2: 127.62
  })), _polyline110 || (_polyline110 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "181.84 127.62 180.72 127.62 180.72 126.5"
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 180.72,
    y1: 124.25,
    x2: 180.72,
    y2: 107.41
  })), _polyline111 || (_polyline111 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "180.72 106.28 180.72 105.16 181.84 105.16"
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 184.09,
    y1: 105.16,
    x2: 200.93,
    y2: 105.16
  })), _polyline112 || (_polyline112 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "202.05 105.16 203.18 105.16 203.18 106.28"
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 203.18,
    y1: 108.53,
    x2: 203.18,
    y2: 125.37
  })), _polyline113 || (_polyline113 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "34.58 155.2 34.58 156.32 33.46 156.32"
  })), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.22,
    y1: 156.32,
    x2: 14.37,
    y2: 156.32
  })), _polyline114 || (_polyline114 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "13.25 156.32 12.13 156.32 12.13 155.2"
  })), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.12,
    y1: 152.95,
    x2: 12.12,
    y2: 136.11
  })), _polyline115 || (_polyline115 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12.13 134.98 12.13 133.86 13.25 133.86"
  })), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.49,
    y1: 133.86,
    x2: 32.34,
    y2: 133.86
  })), _polyline116 || (_polyline116 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "33.46 133.86 34.58 133.86 34.58 134.98"
  })), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 34.58,
    y1: 137.23,
    x2: 34.58,
    y2: 154.07
  })), _polyline117 || (_polyline117 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "62.62 155.2 62.62 156.32 61.5 156.32"
  })), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59.25,
    y1: 156.32,
    x2: 42.41,
    y2: 156.32
  })), _polyline118 || (_polyline118 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "41.29 156.32 40.16 156.32 40.16 155.2"
  })), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.16,
    y1: 152.95,
    x2: 40.16,
    y2: 136.11
  })), _polyline119 || (_polyline119 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.16 134.98 40.16 133.86 41.29 133.86"
  })), _line119 || (_line119 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.53,
    y1: 133.86,
    x2: 60.38,
    y2: 133.86
  })), _polyline120 || (_polyline120 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "61.5 133.86 62.62 133.86 62.62 134.98"
  })), _line120 || (_line120 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.62,
    y1: 137.23,
    x2: 62.62,
    y2: 154.07
  })), _polyline121 || (_polyline121 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "90.66 155.2 90.66 156.32 89.54 156.32"
  })), _line121 || (_line121 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.29,
    y1: 156.32,
    x2: 70.45,
    y2: 156.32
  })), _polyline122 || (_polyline122 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "69.33 156.32 68.2 156.32 68.2 155.2"
  })), _line122 || (_line122 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.2,
    y1: 152.95,
    x2: 68.2,
    y2: 136.11
  })), _polyline123 || (_polyline123 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "68.2 134.98 68.2 133.86 69.33 133.86"
  })), _line123 || (_line123 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.57,
    y1: 133.86,
    x2: 88.42,
    y2: 133.86
  })), _polyline124 || (_polyline124 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "89.54 133.86 90.66 133.86 90.66 134.98"
  })), _line124 || (_line124 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.66,
    y1: 137.23,
    x2: 90.66,
    y2: 154.07
  })), _polyline125 || (_polyline125 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "118.7 155.2 118.7 156.32 117.58 156.32"
  })), _line125 || (_line125 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 115.33,
    y1: 156.32,
    x2: 98.49,
    y2: 156.32
  })), _polyline126 || (_polyline126 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "97.36 156.32 96.24 156.32 96.24 155.2"
  })), _line126 || (_line126 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.24,
    y1: 152.95,
    x2: 96.24,
    y2: 136.11
  })), _polyline127 || (_polyline127 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "96.24 134.98 96.24 133.86 97.36 133.86"
  })), _line127 || (_line127 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.61,
    y1: 133.86,
    x2: 116.46,
    y2: 133.86
  })), _polyline128 || (_polyline128 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "117.58 133.86 118.7 133.86 118.7 134.98"
  })), _line128 || (_line128 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 118.7,
    y1: 137.23,
    x2: 118.7,
    y2: 154.07
  })), _polyline129 || (_polyline129 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "146.74 155.2 146.74 156.32 145.62 156.32"
  })), _line129 || (_line129 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 143.37,
    y1: 156.32,
    x2: 126.53,
    y2: 156.32
  })), _polyline130 || (_polyline130 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "125.4 156.32 124.28 156.32 124.28 155.2"
  })), _line130 || (_line130 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 124.28,
    y1: 152.95,
    x2: 124.28,
    y2: 136.11
  })), _polyline131 || (_polyline131 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "124.28 134.98 124.28 133.86 125.4 133.86"
  })), _line131 || (_line131 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 127.65,
    y1: 133.86,
    x2: 144.49,
    y2: 133.86
  })), _polyline132 || (_polyline132 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "145.62 133.86 146.74 133.86 146.74 134.98"
  })), _line132 || (_line132 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 146.74,
    y1: 137.23,
    x2: 146.74,
    y2: 154.07
  })), _polyline133 || (_polyline133 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "174.96 155.42 174.96 156.54 173.84 156.54"
  })), _line133 || (_line133 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.59,
    y1: 156.54,
    x2: 154.74,
    y2: 156.54
  })), _polyline134 || (_polyline134 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "153.62 156.54 152.5 156.54 152.5 155.42"
  })), _line134 || (_line134 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 152.5,
    y1: 153.17,
    x2: 152.5,
    y2: 136.33
  })), _polyline135 || (_polyline135 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "152.5 135.21 152.5 134.08 153.62 134.08"
  })), _line135 || (_line135 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 155.87,
    y1: 134.08,
    x2: 172.71,
    y2: 134.08
  })), _polyline136 || (_polyline136 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "173.84 134.08 174.96 134.08 174.96 135.21"
  })), _line136 || (_line136 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.96,
    y1: 137.45,
    x2: 174.96,
    y2: 154.3
  })), _polyline137 || (_polyline137 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "203.18 155.65 203.18 156.77 202.05 156.77"
  })), _line137 || (_line137 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 199.81,
    y1: 156.77,
    x2: 182.96,
    y2: 156.77
  })), _polyline138 || (_polyline138 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "181.84 156.77 180.72 156.77 180.72 155.65"
  })), _line138 || (_line138 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 180.72,
    y1: 153.4,
    x2: 180.72,
    y2: 136.55
  })), _polyline139 || (_polyline139 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "180.72 135.43 180.72 134.31 181.84 134.31"
  })), _line139 || (_line139 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 184.09,
    y1: 134.31,
    x2: 200.93,
    y2: 134.31
  })), _polyline140 || (_polyline140 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "202.05 134.31 203.18 134.31 203.18 135.43"
  })), _line140 || (_line140 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 203.18,
    y1: 137.68,
    x2: 203.18,
    y2: 154.52
  })), _polyline141 || (_polyline141 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "34.58 184.34 34.58 185.47 33.46 185.47"
  })), _line141 || (_line141 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.22,
    y1: 185.47,
    x2: 14.37,
    y2: 185.47
  })), _polyline142 || (_polyline142 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "13.25 185.47 12.13 185.47 12.13 184.34"
  })), _line142 || (_line142 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.12,
    y1: 182.1,
    x2: 12.12,
    y2: 165.25
  })), _polyline143 || (_polyline143 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12.13 164.13 12.13 163.01 13.25 163.01"
  })), _line143 || (_line143 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.49,
    y1: 163.01,
    x2: 32.34,
    y2: 163.01
  })), _polyline144 || (_polyline144 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "33.46 163.01 34.58 163.01 34.58 164.13"
  })), _line144 || (_line144 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 34.58,
    y1: 166.38,
    x2: 34.58,
    y2: 183.22
  })), _polyline145 || (_polyline145 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "62.62 184.34 62.62 185.47 61.5 185.47"
  })), _line145 || (_line145 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59.25,
    y1: 185.47,
    x2: 42.41,
    y2: 185.47
  })), _polyline146 || (_polyline146 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "41.29 185.47 40.16 185.47 40.16 184.34"
  })), _line146 || (_line146 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.16,
    y1: 182.1,
    x2: 40.16,
    y2: 165.25
  })), _polyline147 || (_polyline147 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.16 164.13 40.16 163.01 41.29 163.01"
  })), _line147 || (_line147 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.53,
    y1: 163.01,
    x2: 60.38,
    y2: 163.01
  })), _polyline148 || (_polyline148 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "61.5 163.01 62.62 163.01 62.62 164.13"
  })), _line148 || (_line148 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.62,
    y1: 166.38,
    x2: 62.62,
    y2: 183.22
  })), _polyline149 || (_polyline149 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "90.66 184.34 90.66 185.47 89.54 185.47"
  })), _line149 || (_line149 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.29,
    y1: 185.47,
    x2: 70.45,
    y2: 185.47
  })), _polyline150 || (_polyline150 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "69.33 185.47 68.2 185.47 68.2 184.34"
  })), _line150 || (_line150 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.2,
    y1: 182.1,
    x2: 68.2,
    y2: 165.25
  })), _polyline151 || (_polyline151 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "68.2 164.13 68.2 163.01 69.33 163.01"
  })), _line151 || (_line151 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.57,
    y1: 163.01,
    x2: 88.42,
    y2: 163.01
  })), _polyline152 || (_polyline152 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "89.54 163.01 90.66 163.01 90.66 164.13"
  })), _line152 || (_line152 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.66,
    y1: 166.38,
    x2: 90.66,
    y2: 183.22
  })), _polyline153 || (_polyline153 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "118.7 184.34 118.7 185.47 117.58 185.47"
  })), _line153 || (_line153 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 115.33,
    y1: 185.47,
    x2: 98.49,
    y2: 185.47
  })), _polyline154 || (_polyline154 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "97.36 185.47 96.24 185.47 96.24 184.34"
  })), _line154 || (_line154 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.24,
    y1: 182.1,
    x2: 96.24,
    y2: 165.25
  })), _polyline155 || (_polyline155 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "96.24 164.13 96.24 163.01 97.36 163.01"
  })), _line155 || (_line155 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.61,
    y1: 163.01,
    x2: 116.46,
    y2: 163.01
  })), _polyline156 || (_polyline156 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "117.58 163.01 118.7 163.01 118.7 164.13"
  })), _line156 || (_line156 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 118.7,
    y1: 166.38,
    x2: 118.7,
    y2: 183.22
  })), _polyline157 || (_polyline157 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "146.74 184.34 146.74 185.47 145.62 185.47"
  })), _line157 || (_line157 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 143.37,
    y1: 185.47,
    x2: 126.53,
    y2: 185.47
  })), _polyline158 || (_polyline158 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "125.4 185.47 124.28 185.47 124.28 184.34"
  })), _line158 || (_line158 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 124.28,
    y1: 182.1,
    x2: 124.28,
    y2: 165.25
  })), _polyline159 || (_polyline159 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "124.28 164.13 124.28 163.01 125.4 163.01"
  })), _line159 || (_line159 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 127.65,
    y1: 163.01,
    x2: 144.49,
    y2: 163.01
  })), _polyline160 || (_polyline160 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "145.62 163.01 146.74 163.01 146.74 164.13"
  })), _line160 || (_line160 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 146.74,
    y1: 166.38,
    x2: 146.74,
    y2: 183.22
  })), _polyline161 || (_polyline161 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "174.96 184.57 174.96 185.69 173.84 185.69"
  })), _line161 || (_line161 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.59,
    y1: 185.69,
    x2: 154.74,
    y2: 185.69
  })), _polyline162 || (_polyline162 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "153.62 185.69 152.5 185.69 152.5 184.57"
  })), _line162 || (_line162 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 152.5,
    y1: 182.32,
    x2: 152.5,
    y2: 165.48
  })), _polyline163 || (_polyline163 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "152.5 164.35 152.5 163.23 153.62 163.23"
  })), _line163 || (_line163 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 155.87,
    y1: 163.23,
    x2: 172.71,
    y2: 163.23
  })), _polyline164 || (_polyline164 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "173.84 163.23 174.96 163.23 174.96 164.35"
  })), _line164 || (_line164 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.96,
    y1: 166.6,
    x2: 174.96,
    y2: 183.45
  })), _polyline165 || (_polyline165 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "203.18 184.79 203.18 185.92 202.05 185.92"
  })), _line165 || (_line165 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 199.81,
    y1: 185.92,
    x2: 182.96,
    y2: 185.92
  })), _polyline166 || (_polyline166 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "181.84 185.92 180.72 185.92 180.72 184.79"
  })), _line166 || (_line166 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 180.72,
    y1: 182.55,
    x2: 180.72,
    y2: 165.7
  })), _polyline167 || (_polyline167 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "180.72 164.58 180.72 163.46 181.84 163.46"
  })), _line167 || (_line167 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 184.09,
    y1: 163.46,
    x2: 200.93,
    y2: 163.46
  })), _polyline168 || (_polyline168 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "202.05 163.46 203.18 163.46 203.18 164.58"
  })), _line168 || (_line168 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 203.18,
    y1: 166.83,
    x2: 203.18,
    y2: 183.67
  })), _polyline169 || (_polyline169 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "34.58 213.49 34.58 214.62 33.46 214.62"
  })), _line169 || (_line169 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.22,
    y1: 214.62,
    x2: 14.37,
    y2: 214.62
  })), _polyline170 || (_polyline170 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "13.25 214.62 12.13 214.62 12.13 213.49"
  })), _line170 || (_line170 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.12,
    y1: 211.25,
    x2: 12.12,
    y2: 194.4
  })), _polyline171 || (_polyline171 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12.13 193.28 12.13 192.16 13.25 192.16"
  })), _line171 || (_line171 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.49,
    y1: 192.16,
    x2: 32.34,
    y2: 192.16
  })), _polyline172 || (_polyline172 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "33.46 192.16 34.58 192.16 34.58 193.28"
  })), _line172 || (_line172 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 34.58,
    y1: 195.52,
    x2: 34.58,
    y2: 212.37
  })), _polyline173 || (_polyline173 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "62.62 213.49 62.62 214.62 61.5 214.62"
  })), _line173 || (_line173 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59.25,
    y1: 214.62,
    x2: 42.41,
    y2: 214.62
  })), _polyline174 || (_polyline174 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "41.29 214.62 40.16 214.62 40.16 213.49"
  })), _line174 || (_line174 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.16,
    y1: 211.25,
    x2: 40.16,
    y2: 194.4
  })), _polyline175 || (_polyline175 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.16 193.28 40.16 192.16 41.29 192.16"
  })), _line175 || (_line175 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.53,
    y1: 192.16,
    x2: 60.38,
    y2: 192.16
  })), _polyline176 || (_polyline176 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "61.5 192.16 62.62 192.16 62.62 193.28"
  })), _line176 || (_line176 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.62,
    y1: 195.52,
    x2: 62.62,
    y2: 212.37
  })), _polyline177 || (_polyline177 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "90.66 213.49 90.66 214.62 89.54 214.62"
  })), _line177 || (_line177 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.29,
    y1: 214.62,
    x2: 70.45,
    y2: 214.62
  })), _polyline178 || (_polyline178 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "69.33 214.62 68.2 214.62 68.2 213.49"
  })), _line178 || (_line178 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.2,
    y1: 211.25,
    x2: 68.2,
    y2: 194.4
  })), _polyline179 || (_polyline179 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "68.2 193.28 68.2 192.16 69.33 192.16"
  })), _line179 || (_line179 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.57,
    y1: 192.16,
    x2: 88.42,
    y2: 192.16
  })), _polyline180 || (_polyline180 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "89.54 192.16 90.66 192.16 90.66 193.28"
  })), _line180 || (_line180 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.66,
    y1: 195.52,
    x2: 90.66,
    y2: 212.37
  })), _polyline181 || (_polyline181 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "118.7 213.49 118.7 214.62 117.58 214.62"
  })), _line181 || (_line181 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 115.33,
    y1: 214.62,
    x2: 98.49,
    y2: 214.62
  })), _polyline182 || (_polyline182 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "97.36 214.62 96.24 214.62 96.24 213.49"
  })), _line182 || (_line182 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.24,
    y1: 211.25,
    x2: 96.24,
    y2: 194.4
  })), _polyline183 || (_polyline183 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "96.24 193.28 96.24 192.16 97.36 192.16"
  })), _line183 || (_line183 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.61,
    y1: 192.16,
    x2: 116.46,
    y2: 192.16
  })), _polyline184 || (_polyline184 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "117.58 192.16 118.7 192.16 118.7 193.28"
  })), _line184 || (_line184 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 118.7,
    y1: 195.52,
    x2: 118.7,
    y2: 212.37
  })), _polyline185 || (_polyline185 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "146.74 213.49 146.74 214.62 145.62 214.62"
  })), _line185 || (_line185 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 143.37,
    y1: 214.62,
    x2: 126.53,
    y2: 214.62
  })), _polyline186 || (_polyline186 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "125.4 214.62 124.28 214.62 124.28 213.49"
  })), _line186 || (_line186 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 124.28,
    y1: 211.25,
    x2: 124.28,
    y2: 194.4
  })), _polyline187 || (_polyline187 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "124.28 193.28 124.28 192.16 125.4 192.16"
  })), _line187 || (_line187 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 127.65,
    y1: 192.16,
    x2: 144.49,
    y2: 192.16
  })), _polyline188 || (_polyline188 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "145.62 192.16 146.74 192.16 146.74 193.28"
  })), _line188 || (_line188 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 146.74,
    y1: 195.52,
    x2: 146.74,
    y2: 212.37
  })), _polyline189 || (_polyline189 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "174.96 213.72 174.96 214.84 173.84 214.84"
  })), _line189 || (_line189 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.59,
    y1: 214.84,
    x2: 154.74,
    y2: 214.84
  })), _polyline190 || (_polyline190 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "153.62 214.84 152.5 214.84 152.5 213.72"
  })), _line190 || (_line190 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 152.5,
    y1: 211.47,
    x2: 152.5,
    y2: 194.63
  })), _polyline191 || (_polyline191 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "152.5 193.5 152.5 192.38 153.62 192.38"
  })), _line191 || (_line191 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 155.87,
    y1: 192.38,
    x2: 172.71,
    y2: 192.38
  })), _polyline192 || (_polyline192 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "173.84 192.38 174.96 192.38 174.96 193.5"
  })), _line192 || (_line192 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.96,
    y1: 195.75,
    x2: 174.96,
    y2: 212.59
  })), _polyline193 || (_polyline193 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "203.18 213.94 203.18 215.06 202.05 215.06"
  })), _line193 || (_line193 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 199.81,
    y1: 215.06,
    x2: 182.96,
    y2: 215.06
  })), _polyline194 || (_polyline194 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "181.84 215.06 180.72 215.06 180.72 213.94"
  })), _line194 || (_line194 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 180.72,
    y1: 211.7,
    x2: 180.72,
    y2: 194.85
  })), _polyline195 || (_polyline195 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "180.72 193.73 180.72 192.6 181.84 192.6"
  })), _line195 || (_line195 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 184.09,
    y1: 192.6,
    x2: 200.93,
    y2: 192.6
  })), _polyline196 || (_polyline196 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "202.05 192.6 203.18 192.6 203.18 193.73"
  })), _line196 || (_line196 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 203.18,
    y1: 195.97,
    x2: 203.18,
    y2: 212.82
  })), _polyline197 || (_polyline197 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "34.58 242.64 34.58 243.76 33.46 243.76"
  })), _line197 || (_line197 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.22,
    y1: 243.76,
    x2: 14.37,
    y2: 243.76
  })), _polyline198 || (_polyline198 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "13.25 243.76 12.13 243.76 12.13 242.64"
  })), _line198 || (_line198 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.12,
    y1: 240.39,
    x2: 12.12,
    y2: 223.55
  })), _polyline199 || (_polyline199 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12.13 222.43 12.13 221.3 13.25 221.3"
  })), _line199 || (_line199 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.49,
    y1: 221.3,
    x2: 32.34,
    y2: 221.3
  })), _polyline200 || (_polyline200 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "33.46 221.3 34.58 221.3 34.58 222.43"
  })), _line200 || (_line200 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 34.58,
    y1: 224.67,
    x2: 34.58,
    y2: 241.52
  })), _polyline201 || (_polyline201 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "62.62 242.64 62.62 243.76 61.5 243.76"
  })), _line201 || (_line201 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59.25,
    y1: 243.76,
    x2: 42.41,
    y2: 243.76
  })), _polyline202 || (_polyline202 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "41.29 243.76 40.16 243.76 40.16 242.64"
  })), _line202 || (_line202 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.16,
    y1: 240.39,
    x2: 40.16,
    y2: 223.55
  })), _polyline203 || (_polyline203 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.16 222.43 40.16 221.3 41.29 221.3"
  })), _line203 || (_line203 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.53,
    y1: 221.3,
    x2: 60.38,
    y2: 221.3
  })), _polyline204 || (_polyline204 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "61.5 221.3 62.62 221.3 62.62 222.43"
  })), _line204 || (_line204 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.62,
    y1: 224.67,
    x2: 62.62,
    y2: 241.52
  })), _polyline205 || (_polyline205 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "90.66 242.64 90.66 243.76 89.54 243.76"
  })), _line205 || (_line205 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.29,
    y1: 243.76,
    x2: 70.45,
    y2: 243.76
  })), _polyline206 || (_polyline206 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "69.33 243.76 68.2 243.76 68.2 242.64"
  })), _line206 || (_line206 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.2,
    y1: 240.39,
    x2: 68.2,
    y2: 223.55
  })), _polyline207 || (_polyline207 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "68.2 222.43 68.2 221.3 69.33 221.3"
  })), _line207 || (_line207 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.57,
    y1: 221.3,
    x2: 88.42,
    y2: 221.3
  })), _polyline208 || (_polyline208 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "89.54 221.3 90.66 221.3 90.66 222.43"
  })), _line208 || (_line208 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.66,
    y1: 224.67,
    x2: 90.66,
    y2: 241.52
  })), _polyline209 || (_polyline209 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "118.7 242.64 118.7 243.76 117.58 243.76"
  })), _line209 || (_line209 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 115.33,
    y1: 243.76,
    x2: 98.49,
    y2: 243.76
  })), _polyline210 || (_polyline210 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "97.36 243.76 96.24 243.76 96.24 242.64"
  })), _line210 || (_line210 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.24,
    y1: 240.39,
    x2: 96.24,
    y2: 223.55
  })), _polyline211 || (_polyline211 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "96.24 222.43 96.24 221.3 97.36 221.3"
  })), _line211 || (_line211 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.61,
    y1: 221.3,
    x2: 116.46,
    y2: 221.3
  })), _polyline212 || (_polyline212 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "117.58 221.3 118.7 221.3 118.7 222.43"
  })), _line212 || (_line212 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 118.7,
    y1: 224.67,
    x2: 118.7,
    y2: 241.52
  })), _polyline213 || (_polyline213 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "146.74 242.64 146.74 243.76 145.62 243.76"
  })), _line213 || (_line213 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 143.37,
    y1: 243.76,
    x2: 126.53,
    y2: 243.76
  })), _polyline214 || (_polyline214 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "125.4 243.76 124.28 243.76 124.28 242.64"
  })), _line214 || (_line214 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 124.28,
    y1: 240.39,
    x2: 124.28,
    y2: 223.55
  })), _polyline215 || (_polyline215 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "124.28 222.43 124.28 221.3 125.4 221.3"
  })), _line215 || (_line215 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 127.65,
    y1: 221.3,
    x2: 144.49,
    y2: 221.3
  })), _polyline216 || (_polyline216 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "145.62 221.3 146.74 221.3 146.74 222.43"
  })), _line216 || (_line216 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 146.74,
    y1: 224.67,
    x2: 146.74,
    y2: 241.52
  })), _polyline217 || (_polyline217 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "174.96 242.87 174.96 243.99 173.84 243.99"
  })), _line217 || (_line217 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.59,
    y1: 243.99,
    x2: 154.74,
    y2: 243.99
  })), _polyline218 || (_polyline218 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "153.62 243.99 152.5 243.99 152.5 242.87"
  })), _line218 || (_line218 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 152.5,
    y1: 240.62,
    x2: 152.5,
    y2: 223.77
  })), _polyline219 || (_polyline219 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "152.5 222.65 152.5 221.53 153.62 221.53"
  })), _line219 || (_line219 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 155.87,
    y1: 221.53,
    x2: 172.71,
    y2: 221.53
  })), _polyline220 || (_polyline220 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "173.84 221.53 174.96 221.53 174.96 222.65"
  })), _line220 || (_line220 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.96,
    y1: 224.9,
    x2: 174.96,
    y2: 241.74
  })), _polyline221 || (_polyline221 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "203.18 243.09 203.18 244.21 202.05 244.21"
  })), _line221 || (_line221 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 199.81,
    y1: 244.21,
    x2: 182.96,
    y2: 244.21
  })), _polyline222 || (_polyline222 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "181.84 244.21 180.72 244.21 180.72 243.09"
  })), _line222 || (_line222 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 180.72,
    y1: 240.84,
    x2: 180.72,
    y2: 224
  })), _polyline223 || (_polyline223 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "180.72 222.88 180.72 221.75 181.84 221.75"
  })), _line223 || (_line223 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 184.09,
    y1: 221.75,
    x2: 200.93,
    y2: 221.75
  })), _polyline224 || (_polyline224 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "202.05 221.75 203.18 221.75 203.18 222.88"
  })), _line224 || (_line224 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 203.18,
    y1: 225.12,
    x2: 203.18,
    y2: 241.97
  })), _polyline225 || (_polyline225 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "34.58 271.79 34.58 272.91 33.46 272.91"
  })), _line225 || (_line225 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.22,
    y1: 272.91,
    x2: 14.37,
    y2: 272.91
  })), _polyline226 || (_polyline226 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "13.25 272.91 12.13 272.91 12.13 271.79"
  })), _line226 || (_line226 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.12,
    y1: 269.54,
    x2: 12.12,
    y2: 252.7
  })), _polyline227 || (_polyline227 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12.13 251.57 12.13 250.45 13.25 250.45"
  })), _line227 || (_line227 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.49,
    y1: 250.45,
    x2: 32.34,
    y2: 250.45
  })), _polyline228 || (_polyline228 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "33.46 250.45 34.58 250.45 34.58 251.57"
  })), _line228 || (_line228 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 34.58,
    y1: 253.82,
    x2: 34.58,
    y2: 270.67
  })), _polyline229 || (_polyline229 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "62.62 271.79 62.62 272.91 61.5 272.91"
  })), _line229 || (_line229 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59.25,
    y1: 272.91,
    x2: 42.41,
    y2: 272.91
  })), _polyline230 || (_polyline230 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "41.29 272.91 40.16 272.91 40.16 271.79"
  })), _line230 || (_line230 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.16,
    y1: 269.54,
    x2: 40.16,
    y2: 252.7
  })), _polyline231 || (_polyline231 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.16 251.57 40.16 250.45 41.29 250.45"
  })), _line231 || (_line231 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.53,
    y1: 250.45,
    x2: 60.38,
    y2: 250.45
  })), _polyline232 || (_polyline232 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "61.5 250.45 62.62 250.45 62.62 251.57"
  })), _line232 || (_line232 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.62,
    y1: 253.82,
    x2: 62.62,
    y2: 270.67
  })), _polyline233 || (_polyline233 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "90.66 271.79 90.66 272.91 89.54 272.91"
  })), _line233 || (_line233 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.29,
    y1: 272.91,
    x2: 70.45,
    y2: 272.91
  })), _polyline234 || (_polyline234 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "69.33 272.91 68.2 272.91 68.2 271.79"
  })), _line234 || (_line234 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.2,
    y1: 269.54,
    x2: 68.2,
    y2: 252.7
  })), _polyline235 || (_polyline235 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "68.2 251.57 68.2 250.45 69.33 250.45"
  })), _line235 || (_line235 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.57,
    y1: 250.45,
    x2: 88.42,
    y2: 250.45
  })), _polyline236 || (_polyline236 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "89.54 250.45 90.66 250.45 90.66 251.57"
  })), _line236 || (_line236 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.66,
    y1: 253.82,
    x2: 90.66,
    y2: 270.67
  })), _polyline237 || (_polyline237 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "118.7 271.79 118.7 272.91 117.58 272.91"
  })), _line237 || (_line237 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 115.33,
    y1: 272.91,
    x2: 98.49,
    y2: 272.91
  })), _polyline238 || (_polyline238 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "97.36 272.91 96.24 272.91 96.24 271.79"
  })), _line238 || (_line238 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.24,
    y1: 269.54,
    x2: 96.24,
    y2: 252.7
  })), _polyline239 || (_polyline239 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "96.24 251.57 96.24 250.45 97.36 250.45"
  })), _line239 || (_line239 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.61,
    y1: 250.45,
    x2: 116.46,
    y2: 250.45
  })), _polyline240 || (_polyline240 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "117.58 250.45 118.7 250.45 118.7 251.57"
  })), _line240 || (_line240 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 118.7,
    y1: 253.82,
    x2: 118.7,
    y2: 270.67
  })), _polyline241 || (_polyline241 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "146.74 271.79 146.74 272.91 145.62 272.91"
  })), _line241 || (_line241 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 143.37,
    y1: 272.91,
    x2: 126.53,
    y2: 272.91
  })), _polyline242 || (_polyline242 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "125.4 272.91 124.28 272.91 124.28 271.79"
  })), _line242 || (_line242 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 124.28,
    y1: 269.54,
    x2: 124.28,
    y2: 252.7
  })), _polyline243 || (_polyline243 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "124.28 251.57 124.28 250.45 125.4 250.45"
  })), _line243 || (_line243 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 127.65,
    y1: 250.45,
    x2: 144.49,
    y2: 250.45
  })), _polyline244 || (_polyline244 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "145.62 250.45 146.74 250.45 146.74 251.57"
  })), _line244 || (_line244 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 146.74,
    y1: 253.82,
    x2: 146.74,
    y2: 270.67
  })), _polyline245 || (_polyline245 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "174.96 272.01 174.96 273.14 173.84 273.14"
  })), _line245 || (_line245 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.59,
    y1: 273.14,
    x2: 154.74,
    y2: 273.14
  })), _polyline246 || (_polyline246 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "153.62 273.14 152.5 273.14 152.5 272.01"
  })), _line246 || (_line246 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 152.5,
    y1: 269.77,
    x2: 152.5,
    y2: 252.92
  })), _polyline247 || (_polyline247 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "152.5 251.8 152.5 250.68 153.62 250.68"
  })), _line247 || (_line247 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 155.87,
    y1: 250.68,
    x2: 172.71,
    y2: 250.68
  })), _polyline248 || (_polyline248 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "173.84 250.68 174.96 250.68 174.96 251.8"
  })), _line248 || (_line248 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.96,
    y1: 254.05,
    x2: 174.96,
    y2: 270.89
  })), _polyline249 || (_polyline249 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "203.18 272.24 203.18 273.36 202.05 273.36"
  })), _line249 || (_line249 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 199.81,
    y1: 273.36,
    x2: 182.96,
    y2: 273.36
  })), _polyline250 || (_polyline250 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "181.84 273.36 180.72 273.36 180.72 272.24"
  })), _line250 || (_line250 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 180.72,
    y1: 269.99,
    x2: 180.72,
    y2: 253.15
  })), _polyline251 || (_polyline251 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "180.72 252.02 180.72 250.9 181.84 250.9"
  })), _line251 || (_line251 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 184.09,
    y1: 250.9,
    x2: 200.93,
    y2: 250.9
  })), _polyline252 || (_polyline252 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "202.05 250.9 203.18 250.9 203.18 252.02"
  })), _line252 || (_line252 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 203.18,
    y1: 254.27,
    x2: 203.18,
    y2: 271.12
  })), _polyline253 || (_polyline253 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "34.58 300.94 34.58 302.06 33.46 302.06"
  })), _line253 || (_line253 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.22,
    y1: 302.06,
    x2: 14.37,
    y2: 302.06
  })), _polyline254 || (_polyline254 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "13.25 302.06 12.13 302.06 12.13 300.94"
  })), _line254 || (_line254 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.12,
    y1: 298.69,
    x2: 12.12,
    y2: 281.85
  })), _polyline255 || (_polyline255 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12.13 280.72 12.13 279.6 13.25 279.6"
  })), _line255 || (_line255 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.49,
    y1: 279.6,
    x2: 32.34,
    y2: 279.6
  })), _polyline256 || (_polyline256 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "33.46 279.6 34.58 279.6 34.58 280.72"
  })), _line256 || (_line256 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 34.58,
    y1: 282.97,
    x2: 34.58,
    y2: 299.81
  })), _polyline257 || (_polyline257 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "62.62 300.94 62.62 302.06 61.5 302.06"
  })), _line257 || (_line257 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59.25,
    y1: 302.06,
    x2: 42.41,
    y2: 302.06
  })), _polyline258 || (_polyline258 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "41.29 302.06 40.16 302.06 40.16 300.94"
  })), _line258 || (_line258 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.16,
    y1: 298.69,
    x2: 40.16,
    y2: 281.85
  })), _polyline259 || (_polyline259 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.16 280.72 40.16 279.6 41.29 279.6"
  })), _line259 || (_line259 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.53,
    y1: 279.6,
    x2: 60.38,
    y2: 279.6
  })), _polyline260 || (_polyline260 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "61.5 279.6 62.62 279.6 62.62 280.72"
  })), _line260 || (_line260 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.62,
    y1: 282.97,
    x2: 62.62,
    y2: 299.81
  })), _polyline261 || (_polyline261 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "90.66 300.94 90.66 302.06 89.54 302.06"
  })), _line261 || (_line261 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.29,
    y1: 302.06,
    x2: 70.45,
    y2: 302.06
  })), _polyline262 || (_polyline262 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "69.33 302.06 68.2 302.06 68.2 300.94"
  })), _line262 || (_line262 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.2,
    y1: 298.69,
    x2: 68.2,
    y2: 281.85
  })), _polyline263 || (_polyline263 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "68.2 280.72 68.2 279.6 69.33 279.6"
  })), _line263 || (_line263 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.57,
    y1: 279.6,
    x2: 88.42,
    y2: 279.6
  })), _polyline264 || (_polyline264 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "89.54 279.6 90.66 279.6 90.66 280.72"
  })), _line264 || (_line264 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.66,
    y1: 282.97,
    x2: 90.66,
    y2: 299.81
  })), _polyline265 || (_polyline265 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "118.7 300.94 118.7 302.06 117.58 302.06"
  })), _line265 || (_line265 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 115.33,
    y1: 302.06,
    x2: 98.49,
    y2: 302.06
  })), _polyline266 || (_polyline266 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "97.36 302.06 96.24 302.06 96.24 300.94"
  })), _line266 || (_line266 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.24,
    y1: 298.69,
    x2: 96.24,
    y2: 281.85
  })), _polyline267 || (_polyline267 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "96.24 280.72 96.24 279.6 97.36 279.6"
  })), _line267 || (_line267 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.61,
    y1: 279.6,
    x2: 116.46,
    y2: 279.6
  })), _polyline268 || (_polyline268 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "117.58 279.6 118.7 279.6 118.7 280.72"
  })), _line268 || (_line268 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 118.7,
    y1: 282.97,
    x2: 118.7,
    y2: 299.81
  })), _polyline269 || (_polyline269 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "146.74 300.94 146.74 302.06 145.62 302.06"
  })), _line269 || (_line269 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 143.37,
    y1: 302.06,
    x2: 126.53,
    y2: 302.06
  })), _polyline270 || (_polyline270 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "125.4 302.06 124.28 302.06 124.28 300.94"
  })), _line270 || (_line270 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 124.28,
    y1: 298.69,
    x2: 124.28,
    y2: 281.85
  })), _polyline271 || (_polyline271 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "124.28 280.72 124.28 279.6 125.4 279.6"
  })), _line271 || (_line271 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 127.65,
    y1: 279.6,
    x2: 144.49,
    y2: 279.6
  })), _polyline272 || (_polyline272 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "145.62 279.6 146.74 279.6 146.74 280.72"
  })), _line272 || (_line272 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 146.74,
    y1: 282.97,
    x2: 146.74,
    y2: 299.81
  })), _polyline273 || (_polyline273 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "174.96 301.16 174.96 302.29 173.84 302.29"
  })), _line273 || (_line273 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.59,
    y1: 302.28,
    x2: 154.74,
    y2: 302.28
  })), _polyline274 || (_polyline274 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "153.62 302.29 152.5 302.29 152.5 301.16"
  })), _line274 || (_line274 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 152.5,
    y1: 298.92,
    x2: 152.5,
    y2: 282.07
  })), _polyline275 || (_polyline275 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "152.5 280.95 152.5 279.82 153.62 279.82"
  })), _line275 || (_line275 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 155.87,
    y1: 279.83,
    x2: 172.71,
    y2: 279.83
  })), _polyline276 || (_polyline276 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "173.84 279.82 174.96 279.82 174.96 280.95"
  })), _line276 || (_line276 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.96,
    y1: 283.19,
    x2: 174.96,
    y2: 300.04
  })), _polyline277 || (_polyline277 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "203.18 301.39 203.18 302.51 202.05 302.51"
  })), _line277 || (_line277 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 199.81,
    y1: 302.51,
    x2: 182.96,
    y2: 302.51
  })), _polyline278 || (_polyline278 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "181.84 302.51 180.72 302.51 180.72 301.39"
  })), _line278 || (_line278 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 180.72,
    y1: 299.14,
    x2: 180.72,
    y2: 282.3
  })), _polyline279 || (_polyline279 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "180.72 281.17 180.72 280.05 181.84 280.05"
  })), _line279 || (_line279 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 184.09,
    y1: 280.05,
    x2: 200.93,
    y2: 280.05
  })), _polyline280 || (_polyline280 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "202.05 280.05 203.18 280.05 203.18 281.17"
  })), _line280 || (_line280 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 203.18,
    y1: 283.42,
    x2: 203.18,
    y2: 300.26
  })), _polyline281 || (_polyline281 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "231.39 39.28 231.39 40.4 230.27 40.4"
  })), _line281 || (_line281 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 228.02,
    y1: 40.4,
    x2: 211.18,
    y2: 40.4
  })), _polyline282 || (_polyline282 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "210.06 40.4 208.93 40.4 208.93 39.28"
  })), _line282 || (_line282 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.93,
    y1: 37.03,
    x2: 208.93,
    y2: 20.19
  })), _polyline283 || (_polyline283 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "208.93 19.06 208.93 17.94 210.06 17.94"
  })), _line283 || (_line283 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 212.3,
    y1: 17.94,
    x2: 229.15,
    y2: 17.94
  })), _polyline284 || (_polyline284 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "230.27 17.94 231.39 17.94 231.39 19.06"
  })), _line284 || (_line284 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 231.39,
    y1: 21.31,
    x2: 231.39,
    y2: 38.15
  })), _polyline285 || (_polyline285 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "231.39 68.42 231.39 69.55 230.27 69.55"
  })), _line285 || (_line285 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 228.02,
    y1: 69.55,
    x2: 211.18,
    y2: 69.55
  })), _polyline286 || (_polyline286 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "210.06 69.55 208.93 69.55 208.93 68.42"
  })), _line286 || (_line286 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.93,
    y1: 66.18,
    x2: 208.93,
    y2: 49.33
  })), _polyline287 || (_polyline287 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "208.93 48.21 208.93 47.09 210.06 47.09"
  })), _line287 || (_line287 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 212.3,
    y1: 47.09,
    x2: 229.15,
    y2: 47.09
  })), _polyline288 || (_polyline288 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "230.27 47.09 231.39 47.09 231.39 48.21"
  })), _line288 || (_line288 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 231.39,
    y1: 50.46,
    x2: 231.39,
    y2: 67.3
  })), _polyline289 || (_polyline289 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "231.39 97.57 231.39 98.7 230.27 98.7"
  })), _line289 || (_line289 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 228.02,
    y1: 98.7,
    x2: 211.18,
    y2: 98.7
  })), _polyline290 || (_polyline290 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "210.06 98.7 208.93 98.7 208.93 97.57"
  })), _line290 || (_line290 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.93,
    y1: 95.33,
    x2: 208.93,
    y2: 78.48
  })), _polyline291 || (_polyline291 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "208.93 77.36 208.93 76.24 210.06 76.24"
  })), _line291 || (_line291 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 212.3,
    y1: 76.24,
    x2: 229.15,
    y2: 76.24
  })), _polyline292 || (_polyline292 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "230.27 76.24 231.39 76.24 231.39 77.36"
  })), _line292 || (_line292 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 231.39,
    y1: 79.61,
    x2: 231.39,
    y2: 96.45
  })), _polyline293 || (_polyline293 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "231.39 126.72 231.39 127.84 230.27 127.84"
  })), _line293 || (_line293 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 228.02,
    y1: 127.84,
    x2: 211.18,
    y2: 127.84
  })), _polyline294 || (_polyline294 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "210.06 127.84 208.93 127.84 208.93 126.72"
  })), _line294 || (_line294 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.93,
    y1: 124.48,
    x2: 208.93,
    y2: 107.63
  })), _polyline295 || (_polyline295 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "208.93 106.51 208.93 105.39 210.06 105.39"
  })), _line295 || (_line295 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 212.3,
    y1: 105.38,
    x2: 229.15,
    y2: 105.38
  })), _polyline296 || (_polyline296 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "230.27 105.39 231.39 105.39 231.39 106.51"
  })), _line296 || (_line296 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 231.39,
    y1: 108.75,
    x2: 231.39,
    y2: 125.6
  })), _polyline297 || (_polyline297 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "231.39 155.87 231.39 156.99 230.27 156.99"
  })), _line297 || (_line297 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 228.02,
    y1: 156.99,
    x2: 211.18,
    y2: 156.99
  })), _polyline298 || (_polyline298 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "210.06 156.99 208.93 156.99 208.93 155.87"
  })), _line298 || (_line298 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.93,
    y1: 153.62,
    x2: 208.93,
    y2: 136.78
  })), _polyline299 || (_polyline299 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "208.93 135.66 208.93 134.53 210.06 134.53"
  })), _line299 || (_line299 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 212.3,
    y1: 134.53,
    x2: 229.15,
    y2: 134.53
  })), _polyline300 || (_polyline300 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "230.27 134.53 231.39 134.53 231.39 135.66"
  })), _line300 || (_line300 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 231.39,
    y1: 137.9,
    x2: 231.39,
    y2: 154.75
  })), _polyline301 || (_polyline301 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "231.39 185.02 231.39 186.14 230.27 186.14"
  })), _line301 || (_line301 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 228.02,
    y1: 186.14,
    x2: 211.18,
    y2: 186.14
  })), _polyline302 || (_polyline302 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "210.06 186.14 208.93 186.14 208.93 185.02"
  })), _line302 || (_line302 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.93,
    y1: 182.77,
    x2: 208.93,
    y2: 165.93
  })), _polyline303 || (_polyline303 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "208.93 164.8 208.93 163.68 210.06 163.68"
  })), _line303 || (_line303 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 212.3,
    y1: 163.68,
    x2: 229.15,
    y2: 163.68
  })), _polyline304 || (_polyline304 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "230.27 163.68 231.39 163.68 231.39 164.8"
  })), _line304 || (_line304 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 231.39,
    y1: 167.05,
    x2: 231.39,
    y2: 183.9
  })), _polyline305 || (_polyline305 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "231.39 214.17 231.39 215.29 230.27 215.29"
  })), _line305 || (_line305 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 228.02,
    y1: 215.29,
    x2: 211.18,
    y2: 215.29
  })), _polyline306 || (_polyline306 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "210.06 215.29 208.93 215.29 208.93 214.17"
  })), _line306 || (_line306 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.93,
    y1: 211.92,
    x2: 208.93,
    y2: 195.08
  })), _polyline307 || (_polyline307 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "208.93 193.95 208.93 192.83 210.06 192.83"
  })), _line307 || (_line307 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 212.3,
    y1: 192.83,
    x2: 229.15,
    y2: 192.83
  })), _polyline308 || (_polyline308 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "230.27 192.83 231.39 192.83 231.39 193.95"
  })), _line308 || (_line308 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 231.39,
    y1: 196.2,
    x2: 231.39,
    y2: 213.04
  })), _polyline309 || (_polyline309 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "231.39 243.31 231.39 244.44 230.27 244.44"
  })), _line309 || (_line309 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 228.02,
    y1: 244.44,
    x2: 211.18,
    y2: 244.44
  })), _polyline310 || (_polyline310 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "210.06 244.44 208.93 244.44 208.93 243.31"
  })), _line310 || (_line310 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.93,
    y1: 241.07,
    x2: 208.93,
    y2: 224.22
  })), _polyline311 || (_polyline311 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "208.93 223.1 208.93 221.98 210.06 221.98"
  })), _line311 || (_line311 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 212.3,
    y1: 221.98,
    x2: 229.15,
    y2: 221.98
  })), _polyline312 || (_polyline312 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "230.27 221.98 231.39 221.98 231.39 223.1"
  })), _line312 || (_line312 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 231.39,
    y1: 225.35,
    x2: 231.39,
    y2: 242.19
  })), _polyline313 || (_polyline313 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "231.39 272.46 231.39 273.59 230.27 273.59"
  })), _line313 || (_line313 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 228.02,
    y1: 273.59,
    x2: 211.18,
    y2: 273.59
  })), _polyline314 || (_polyline314 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "210.06 273.59 208.93 273.59 208.93 272.46"
  })), _line314 || (_line314 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.93,
    y1: 270.22,
    x2: 208.93,
    y2: 253.37
  })), _polyline315 || (_polyline315 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "208.93 252.25 208.93 251.13 210.06 251.13"
  })), _line315 || (_line315 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 212.3,
    y1: 251.13,
    x2: 229.15,
    y2: 251.13
  })), _polyline316 || (_polyline316 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "230.27 251.13 231.39 251.13 231.39 252.25"
  })), _line316 || (_line316 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 231.39,
    y1: 254.5,
    x2: 231.39,
    y2: 271.34
  })), _polyline317 || (_polyline317 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "231.39 301.61 231.39 302.73 230.27 302.73"
  })), _line317 || (_line317 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 228.02,
    y1: 302.73,
    x2: 211.18,
    y2: 302.73
  })), _polyline318 || (_polyline318 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "210.06 302.73 208.93 302.73 208.93 301.61"
  })), _line318 || (_line318 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.93,
    y1: 299.37,
    x2: 208.93,
    y2: 282.52
  })), _polyline319 || (_polyline319 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "208.93 281.4 208.93 280.27 210.06 280.27"
  })), _line319 || (_line319 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 212.3,
    y1: 280.27,
    x2: 229.15,
    y2: 280.27
  })), _polyline320 || (_polyline320 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "230.27 280.27 231.39 280.27 231.39 281.4"
  })), _line320 || (_line320 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 231.39,
    y1: 283.64,
    x2: 231.39,
    y2: 300.49
  })), _polyline321 || (_polyline321 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "259.63 39.28 259.63 40.4 258.51 40.4"
  })), _line321 || (_line321 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 256.27,
    y1: 40.4,
    x2: 239.42,
    y2: 40.4
  })), _polyline322 || (_polyline322 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "238.3 40.4 237.18 40.4 237.18 39.28"
  })), _line322 || (_line322 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 237.17,
    y1: 37.03,
    x2: 237.17,
    y2: 20.19
  })), _polyline323 || (_polyline323 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "237.18 19.06 237.18 17.94 238.3 17.94"
  })), _line323 || (_line323 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 240.54,
    y1: 17.94,
    x2: 257.39,
    y2: 17.94
  })), _polyline324 || (_polyline324 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "258.51 17.94 259.63 17.94 259.63 19.06"
  })), _line324 || (_line324 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 259.63,
    y1: 21.31,
    x2: 259.63,
    y2: 38.15
  })), _polyline325 || (_polyline325 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "259.63 68.42 259.63 69.55 258.51 69.55"
  })), _line325 || (_line325 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 256.27,
    y1: 69.55,
    x2: 239.42,
    y2: 69.55
  })), _polyline326 || (_polyline326 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "238.3 69.55 237.18 69.55 237.18 68.42"
  })), _line326 || (_line326 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 237.17,
    y1: 66.18,
    x2: 237.17,
    y2: 49.33
  })), _polyline327 || (_polyline327 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "237.18 48.21 237.18 47.09 238.3 47.09"
  })), _line327 || (_line327 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 240.54,
    y1: 47.09,
    x2: 257.39,
    y2: 47.09
  })), _polyline328 || (_polyline328 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "258.51 47.09 259.63 47.09 259.63 48.21"
  })), _line328 || (_line328 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 259.63,
    y1: 50.46,
    x2: 259.63,
    y2: 67.3
  })), _polyline329 || (_polyline329 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "259.63 97.57 259.63 98.7 258.51 98.7"
  })), _line329 || (_line329 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 256.27,
    y1: 98.7,
    x2: 239.42,
    y2: 98.7
  })), _polyline330 || (_polyline330 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "238.3 98.7 237.18 98.7 237.18 97.57"
  })), _line330 || (_line330 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 237.17,
    y1: 95.33,
    x2: 237.17,
    y2: 78.48
  })), _polyline331 || (_polyline331 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "237.18 77.36 237.18 76.24 238.3 76.24"
  })), _line331 || (_line331 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 240.54,
    y1: 76.24,
    x2: 257.39,
    y2: 76.24
  })), _polyline332 || (_polyline332 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "258.51 76.24 259.63 76.24 259.63 77.36"
  })), _line332 || (_line332 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 259.63,
    y1: 79.61,
    x2: 259.63,
    y2: 96.45
  })), _polyline333 || (_polyline333 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "259.63 126.72 259.63 127.84 258.51 127.84"
  })), _line333 || (_line333 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 256.27,
    y1: 127.84,
    x2: 239.42,
    y2: 127.84
  })), _polyline334 || (_polyline334 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "238.3 127.84 237.18 127.84 237.18 126.72"
  })), _line334 || (_line334 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 237.17,
    y1: 124.48,
    x2: 237.17,
    y2: 107.63
  })), _polyline335 || (_polyline335 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "237.18 106.51 237.18 105.39 238.3 105.39"
  })), _line335 || (_line335 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 240.54,
    y1: 105.38,
    x2: 257.39,
    y2: 105.38
  })), _polyline336 || (_polyline336 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "258.51 105.39 259.63 105.39 259.63 106.51"
  })), _line336 || (_line336 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 259.63,
    y1: 108.75,
    x2: 259.63,
    y2: 125.6
  })), _polyline337 || (_polyline337 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "259.63 155.87 259.63 156.99 258.51 156.99"
  })), _line337 || (_line337 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 256.27,
    y1: 156.99,
    x2: 239.42,
    y2: 156.99
  })), _polyline338 || (_polyline338 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "238.3 156.99 237.18 156.99 237.18 155.87"
  })), _line338 || (_line338 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 237.17,
    y1: 153.62,
    x2: 237.17,
    y2: 136.78
  })), _polyline339 || (_polyline339 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "237.18 135.66 237.18 134.53 238.3 134.53"
  })), _line339 || (_line339 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 240.54,
    y1: 134.53,
    x2: 257.39,
    y2: 134.53
  })), _polyline340 || (_polyline340 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "258.51 134.53 259.63 134.53 259.63 135.66"
  })), _line340 || (_line340 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 259.63,
    y1: 137.9,
    x2: 259.63,
    y2: 154.75
  })), _polyline341 || (_polyline341 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "259.63 185.02 259.63 186.14 258.51 186.14"
  })), _line341 || (_line341 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 256.27,
    y1: 186.14,
    x2: 239.42,
    y2: 186.14
  })), _polyline342 || (_polyline342 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "238.3 186.14 237.18 186.14 237.18 185.02"
  })), _line342 || (_line342 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 237.17,
    y1: 182.77,
    x2: 237.17,
    y2: 165.93
  })), _polyline343 || (_polyline343 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "237.18 164.8 237.18 163.68 238.3 163.68"
  })), _line343 || (_line343 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 240.54,
    y1: 163.68,
    x2: 257.39,
    y2: 163.68
  })), _polyline344 || (_polyline344 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "258.51 163.68 259.63 163.68 259.63 164.8"
  })), _line344 || (_line344 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 259.63,
    y1: 167.05,
    x2: 259.63,
    y2: 183.9
  })), _polyline345 || (_polyline345 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "259.63 214.17 259.63 215.29 258.51 215.29"
  })), _line345 || (_line345 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 256.27,
    y1: 215.29,
    x2: 239.42,
    y2: 215.29
  })), _polyline346 || (_polyline346 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "238.3 215.29 237.18 215.29 237.18 214.17"
  })), _line346 || (_line346 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 237.17,
    y1: 211.92,
    x2: 237.17,
    y2: 195.08
  })), _polyline347 || (_polyline347 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "237.18 193.95 237.18 192.83 238.3 192.83"
  })), _line347 || (_line347 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 240.54,
    y1: 192.83,
    x2: 257.39,
    y2: 192.83
  })), _polyline348 || (_polyline348 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "258.51 192.83 259.63 192.83 259.63 193.95"
  })), _line348 || (_line348 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 259.63,
    y1: 196.2,
    x2: 259.63,
    y2: 213.04
  })), _polyline349 || (_polyline349 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "259.63 243.31 259.63 244.44 258.51 244.44"
  })), _line349 || (_line349 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 256.27,
    y1: 244.44,
    x2: 239.42,
    y2: 244.44
  })), _polyline350 || (_polyline350 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "238.3 244.44 237.18 244.44 237.18 243.31"
  })), _line350 || (_line350 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 237.17,
    y1: 241.07,
    x2: 237.17,
    y2: 224.22
  })), _polyline351 || (_polyline351 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "237.18 223.1 237.18 221.98 238.3 221.98"
  })), _line351 || (_line351 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 240.54,
    y1: 221.98,
    x2: 257.39,
    y2: 221.98
  })), _polyline352 || (_polyline352 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "258.51 221.98 259.63 221.98 259.63 223.1"
  })), _line352 || (_line352 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 259.63,
    y1: 225.35,
    x2: 259.63,
    y2: 242.19
  })), _polyline353 || (_polyline353 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "259.63 272.46 259.63 273.59 258.51 273.59"
  })), _line353 || (_line353 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 256.27,
    y1: 273.59,
    x2: 239.42,
    y2: 273.59
  })), _polyline354 || (_polyline354 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "238.3 273.59 237.18 273.59 237.18 272.46"
  })), _line354 || (_line354 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 237.17,
    y1: 270.22,
    x2: 237.17,
    y2: 253.37
  })), _polyline355 || (_polyline355 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "237.18 252.25 237.18 251.13 238.3 251.13"
  })), _line355 || (_line355 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 240.54,
    y1: 251.13,
    x2: 257.39,
    y2: 251.13
  })), _polyline356 || (_polyline356 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "258.51 251.13 259.63 251.13 259.63 252.25"
  })), _line356 || (_line356 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 259.63,
    y1: 254.5,
    x2: 259.63,
    y2: 271.34
  })), _polyline357 || (_polyline357 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "259.63 301.61 259.63 302.73 258.51 302.73"
  })), _line357 || (_line357 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 256.27,
    y1: 302.73,
    x2: 239.42,
    y2: 302.73
  })), _polyline358 || (_polyline358 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "238.3 302.73 237.18 302.73 237.18 301.61"
  })), _line358 || (_line358 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 237.17,
    y1: 299.37,
    x2: 237.17,
    y2: 282.52
  })), _polyline359 || (_polyline359 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "237.18 281.4 237.18 280.27 238.3 280.27"
  })), _line359 || (_line359 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 240.54,
    y1: 280.27,
    x2: 257.39,
    y2: 280.27
  })), _polyline360 || (_polyline360 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "258.51 280.27 259.63 280.27 259.63 281.4"
  })), _line360 || (_line360 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 259.63,
    y1: 283.64,
    x2: 259.63,
    y2: 300.49
  })), _polyline361 || (_polyline361 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "287.88 39.28 287.88 40.4 286.75 40.4"
  })), _line361 || (_line361 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 284.51,
    y1: 40.4,
    x2: 267.66,
    y2: 40.4
  })), _polyline362 || (_polyline362 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "266.54 40.4 265.42 40.4 265.42 39.28"
  })), _line362 || (_line362 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 265.42,
    y1: 37.03,
    x2: 265.42,
    y2: 20.19
  })), _polyline363 || (_polyline363 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "265.42 19.06 265.42 17.94 266.54 17.94"
  })), _line363 || (_line363 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 268.78,
    y1: 17.94,
    x2: 285.63,
    y2: 17.94
  })), _polyline364 || (_polyline364 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "286.75 17.94 287.88 17.94 287.88 19.06"
  })), _line364 || (_line364 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 287.88,
    y1: 21.31,
    x2: 287.88,
    y2: 38.15
  })), _polyline365 || (_polyline365 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "287.88 68.42 287.88 69.55 286.75 69.55"
  })), _line365 || (_line365 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 284.51,
    y1: 69.55,
    x2: 267.66,
    y2: 69.55
  })), _polyline366 || (_polyline366 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "266.54 69.55 265.42 69.55 265.42 68.42"
  })), _line366 || (_line366 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 265.42,
    y1: 66.18,
    x2: 265.42,
    y2: 49.33
  })), _polyline367 || (_polyline367 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "265.42 48.21 265.42 47.09 266.54 47.09"
  })), _line367 || (_line367 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 268.78,
    y1: 47.09,
    x2: 285.63,
    y2: 47.09
  })), _polyline368 || (_polyline368 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "286.75 47.09 287.88 47.09 287.88 48.21"
  })), _line368 || (_line368 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 287.88,
    y1: 50.46,
    x2: 287.88,
    y2: 67.3
  })), _polyline369 || (_polyline369 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "287.88 97.57 287.88 98.7 286.75 98.7"
  })), _line369 || (_line369 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 284.51,
    y1: 98.7,
    x2: 267.66,
    y2: 98.7
  })), _polyline370 || (_polyline370 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "266.54 98.7 265.42 98.7 265.42 97.57"
  })), _line370 || (_line370 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 265.42,
    y1: 95.33,
    x2: 265.42,
    y2: 78.48
  })), _polyline371 || (_polyline371 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "265.42 77.36 265.42 76.24 266.54 76.24"
  })), _line371 || (_line371 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 268.78,
    y1: 76.24,
    x2: 285.63,
    y2: 76.24
  })), _polyline372 || (_polyline372 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "286.75 76.24 287.88 76.24 287.88 77.36"
  })), _line372 || (_line372 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 287.88,
    y1: 79.61,
    x2: 287.88,
    y2: 96.45
  })), _polyline373 || (_polyline373 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "287.88 126.72 287.88 127.84 286.75 127.84"
  })), _line373 || (_line373 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 284.51,
    y1: 127.84,
    x2: 267.66,
    y2: 127.84
  })), _polyline374 || (_polyline374 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "266.54 127.84 265.42 127.84 265.42 126.72"
  })), _line374 || (_line374 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 265.42,
    y1: 124.48,
    x2: 265.42,
    y2: 107.63
  })), _polyline375 || (_polyline375 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "265.42 106.51 265.42 105.39 266.54 105.39"
  })), _line375 || (_line375 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 268.78,
    y1: 105.38,
    x2: 285.63,
    y2: 105.38
  })), _polyline376 || (_polyline376 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "286.75 105.39 287.88 105.39 287.88 106.51"
  })), _line376 || (_line376 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 287.88,
    y1: 108.75,
    x2: 287.88,
    y2: 125.6
  })), _polyline377 || (_polyline377 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "287.88 155.87 287.88 156.99 286.75 156.99"
  })), _line377 || (_line377 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 284.51,
    y1: 156.99,
    x2: 267.66,
    y2: 156.99
  })), _polyline378 || (_polyline378 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "266.54 156.99 265.42 156.99 265.42 155.87"
  })), _line378 || (_line378 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 265.42,
    y1: 153.62,
    x2: 265.42,
    y2: 136.78
  })), _polyline379 || (_polyline379 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "265.42 135.66 265.42 134.53 266.54 134.53"
  })), _line379 || (_line379 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 268.78,
    y1: 134.53,
    x2: 285.63,
    y2: 134.53
  })), _polyline380 || (_polyline380 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "286.75 134.53 287.88 134.53 287.88 135.66"
  })), _line380 || (_line380 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 287.88,
    y1: 137.9,
    x2: 287.88,
    y2: 154.75
  })), _polyline381 || (_polyline381 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "287.88 185.02 287.88 186.14 286.75 186.14"
  })), _line381 || (_line381 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 284.51,
    y1: 186.14,
    x2: 267.66,
    y2: 186.14
  })), _polyline382 || (_polyline382 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "266.54 186.14 265.42 186.14 265.42 185.02"
  })), _line382 || (_line382 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 265.42,
    y1: 182.77,
    x2: 265.42,
    y2: 165.93
  })), _polyline383 || (_polyline383 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "265.42 164.8 265.42 163.68 266.54 163.68"
  })), _line383 || (_line383 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 268.78,
    y1: 163.68,
    x2: 285.63,
    y2: 163.68
  })), _polyline384 || (_polyline384 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "286.75 163.68 287.88 163.68 287.88 164.8"
  })), _line384 || (_line384 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 287.88,
    y1: 167.05,
    x2: 287.88,
    y2: 183.9
  })), _polyline385 || (_polyline385 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "287.88 214.17 287.88 215.29 286.75 215.29"
  })), _line385 || (_line385 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 284.51,
    y1: 215.29,
    x2: 267.66,
    y2: 215.29
  })), _polyline386 || (_polyline386 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "266.54 215.29 265.42 215.29 265.42 214.17"
  })), _line386 || (_line386 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 265.42,
    y1: 211.92,
    x2: 265.42,
    y2: 195.08
  })), _polyline387 || (_polyline387 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "265.42 193.95 265.42 192.83 266.54 192.83"
  })), _line387 || (_line387 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 268.78,
    y1: 192.83,
    x2: 285.63,
    y2: 192.83
  })), _polyline388 || (_polyline388 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "286.75 192.83 287.88 192.83 287.88 193.95"
  })), _line388 || (_line388 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 287.88,
    y1: 196.2,
    x2: 287.88,
    y2: 213.04
  })), _polyline389 || (_polyline389 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "287.88 243.31 287.88 244.44 286.75 244.44"
  })), _line389 || (_line389 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 284.51,
    y1: 244.44,
    x2: 267.66,
    y2: 244.44
  })), _polyline390 || (_polyline390 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "266.54 244.44 265.42 244.44 265.42 243.31"
  })), _line390 || (_line390 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 265.42,
    y1: 241.07,
    x2: 265.42,
    y2: 224.22
  })), _polyline391 || (_polyline391 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "265.42 223.1 265.42 221.98 266.54 221.98"
  })), _line391 || (_line391 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 268.78,
    y1: 221.98,
    x2: 285.63,
    y2: 221.98
  })), _polyline392 || (_polyline392 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "286.75 221.98 287.88 221.98 287.88 223.1"
  })), _line392 || (_line392 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 287.88,
    y1: 225.35,
    x2: 287.88,
    y2: 242.19
  })), _polyline393 || (_polyline393 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "287.88 272.46 287.88 273.59 286.75 273.59"
  })), _line393 || (_line393 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 284.51,
    y1: 273.59,
    x2: 267.66,
    y2: 273.59
  })), _polyline394 || (_polyline394 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "266.54 273.59 265.42 273.59 265.42 272.46"
  })), _line394 || (_line394 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 265.42,
    y1: 270.22,
    x2: 265.42,
    y2: 253.37
  })), _polyline395 || (_polyline395 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "265.42 252.25 265.42 251.13 266.54 251.13"
  })), _line395 || (_line395 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 268.78,
    y1: 251.13,
    x2: 285.63,
    y2: 251.13
  })), _polyline396 || (_polyline396 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "286.75 251.13 287.88 251.13 287.88 252.25"
  })), _line396 || (_line396 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 287.88,
    y1: 254.5,
    x2: 287.88,
    y2: 271.34
  })), _polyline397 || (_polyline397 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "287.88 301.61 287.88 302.73 286.75 302.73"
  })), _line397 || (_line397 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 284.51,
    y1: 302.73,
    x2: 267.66,
    y2: 302.73
  })), _polyline398 || (_polyline398 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "266.54 302.73 265.42 302.73 265.42 301.61"
  })), _line398 || (_line398 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 265.42,
    y1: 299.37,
    x2: 265.42,
    y2: 282.52
  })), _polyline399 || (_polyline399 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "265.42 281.4 265.42 280.27 266.54 280.27"
  })), _line399 || (_line399 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 268.78,
    y1: 280.27,
    x2: 285.63,
    y2: 280.27
  })), _polyline400 || (_polyline400 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "286.75 280.27 287.88 280.27 287.88 281.4"
  })), _line400 || (_line400 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 287.88,
    y1: 283.64,
    x2: 287.88,
    y2: 300.49
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewOrderBgTab);
export default __webpack_public_path__ + "static/media/preview-order-bg-tab.0aa661a75d3ae2406cee2c1e6805c820.svg";
export { ForwardRef as ReactComponent };